import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {BootstrapVue, IconsPlugin, TablePlugin,ProgressPlugin,DropdownPlugin } from 'bootstrap-vue'
import Toasted from 'vue-toasted';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, numeric, max_value } from 'vee-validate/dist/rules';


import "bootstrap/dist/css/bootstrap.min.css";
import 'jquery/src/jquery.js'
import "bootstrap/dist/js/bootstrap.min.js";

import Multiselect from 'vue-multiselect';
import "@/styles/scss/style.scss";

import { utilMixins } from './utils/utils-mixins'


Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(TablePlugin);
Vue.use(ProgressPlugin);
Vue.use(DropdownPlugin);
Vue.use(Toasted)
Vue.mixin(utilMixins);



Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('multiselect', Multiselect);

Vue.config.productionTip = false

extend('required', {
    ...required,
    message: 'Ce champ est obligatoire'
});

extend('numeric', {
    ...numeric,
    message: 'Ce champ doit etre un nombre'
});


extend('max_value', {
    ...max_value,
    message: 'Ce nombre est superieur a la quantite disponible'
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
